import { render, staticRenderFns } from "./EntityTexts.vue?vue&type=template&id=37bee042&"
import script from "./EntityTexts.vue?vue&type=script&lang=js&"
export * from "./EntityTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports